import React from 'react';
import Link from 'next/link';
import { useRouter } from "next/router";
import { LinkObject } from '../helper/interfaces';
import { useLoggedRouter } from '../helper/useLoggedRouter';
import { ChevronRight } from 'react-feather';

interface LinkedModuleTitleProps {
  link: LinkObject;
  title: string;
  moduleId: string;
  navigate: (id?: string, ressortId?: string, moduleId?: string) => void;
}

export default function LinkedModuleTitle({ link, title, moduleId, navigate }: LinkedModuleTitleProps) {

  return (<>
  {link?.internalLink && link?.ressortId && <div onClick={() => navigate(undefined, link.ressortId, moduleId)} >
      {title}<ChevronRight className="inline w-4 h-4 relative -top-px -mt-px ml-0.5" />
    </div>
  }
  {link?.internalLink && link?.articleId && <div onClick={() => navigate(link.articleId, undefined, moduleId)}>
      {title}<ChevronRight className="inline w-4 h-4 relative -top-px -mt-px ml-0.5" />
    </div>
  }
  {link?.externalLink && 
    <a href={link.externalLink} target="_blank" rel="noopener noreferrer">
      {title}<ChevronRight className="inline w-4 h-4 relative -top-px -mt-px ml-0.5" />
    </a>
  }
  {!link?.internalLink && !link?.externalLink && 
  <>
  {title}
  </>
  }
  </>
  );
} 